export const TwitterSecond = ({ width = '14', height = '13' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.643 4.937a9.41 9.41 0 0 1-2.77.799 4.808 4.808 0 0 0 2.106-2.645 9.681 9.681 0 0 1-3.059 1.2 4.784 4.784 0 0 0-8.233 4.365A13.583 13.583 0 0 1 1.67 3.15 4.788 4.788 0 0 0 3.084 9.86 4.738 4.738 0 0 1 .96 9.2v.06a4.786 4.786 0 0 0 3.834 4.683 4.773 4.773 0 0 1-2.162.084 4.789 4.789 0 0 0 4.467 3.315A9.598 9.598 0 0 1 .99 19.544a13.519 13.519 0 0 0 7.29 2.14c8.754 0 13.54-7.249 13.54-13.54 0-.205 0-.408-.015-.61A9.72 9.72 0 0 0 24 4.57a9.36 9.36 0 0 1-2.357.632z"
        fill="white"
      />
    </svg>
  );
};
